import { Button } from '@/components/ui/Button';
import { XStack, YStack } from '@/components/ui/layout/layout';
import { useHashRoute } from '@/hooks/useHashRoute';
import { cn } from '@/lib/utils';
import { trackEvent } from '@/utils/analytics';

export const Root = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <XStack
      className={cn(
        'items-center justify-between gap-6',
        'border border-border-strong',
        'p-4',
        'shadow-sm',
        'rounded-xl',
        'bg-surface',
        className
      )}
    >
      {children}
    </XStack>
  );
};

export const Content = ({ children }: { children: React.ReactNode }) => {
  return <YStack className="px-1.5">{children}</YStack>;
};

export const Title = ({ children }: { children: React.ReactNode }) => {
  return <span className="font-bold text-foreground-subtle">{children}</span>;
};

export const Description = ({ children }: { children: React.ReactNode }) => {
  return (
    <span className="text-sm text-foreground-muted leading-relaxed">
      {children}
    </span>
  );
};

export const UpgradeButton = ({
  children,
  source,
}: {
  children: React.ReactNode;
  source?: string;
}) => {
  const { setHash } = useHashRoute();
  const handleUpgrade = () => {
    trackEvent('UPGRADE_BUTTON_CLICKED', {
      source: source ?? 'upgrade_banner',
    });
    setHash('settings/Subscription');
  };
  return <Button onClick={handleUpgrade}>{children}</Button>;
};
